export default class CatalogAttrConst {
 
  static TIPOATTR_PROP = "tipoattr-prop";
  static TIPOATTR_PROPCUS = "tipoattr-propcustom";
  static TIPOATTR_COMMON = "tipoattr-propcom";
  
  }
  